import { uniq } from "lodash-es";

export const getMergedDefaultStepsForGroups = (
  defaultStepTagForGroups: Record<string, string> | undefined,
  defaultStepTagForGroupsChanges: Record<string, string> | undefined
): Record<string, string> | undefined => {
  if (!defaultStepTagForGroupsChanges) {
    return defaultStepTagForGroups;
  } else if (!defaultStepTagForGroups) {
    return defaultStepTagForGroupsChanges;
  }
  const uniqueGroupNames = uniq([
    ...Object.keys(defaultStepTagForGroups),
    ...Object.keys(defaultStepTagForGroupsChanges)
  ]);
  return uniqueGroupNames.reduce((acc: Record<string, string>, groupName) => {
    acc[groupName] =
      defaultStepTagForGroups[groupName] ??
      defaultStepTagForGroupsChanges[groupName] ??
      "";

    return acc;
  }, {});
};
